import { Listing } from 'shared/@types';
import { AnalyticsEventParams } from 'shared/library/analytics';

export function getPetInsuranceWidgetAnalyticsParams(
  listing: Listing,
  insurancePartnerName: string,
  routeName?: string | null,
): AnalyticsEventParams {
  const params: AnalyticsEventParams = {
    widget_type: 'pet_insurance',
    insurance_partner: insurancePartnerName,
  };

  if (routeName) {
    params.route_name = routeName;
  }

  if (listing.animal) {
    params.animal = listing.animal;
  }

  if (listing.breed_id) {
    params.breed_id = listing.breed_id;
  }

  return params;
}
